import { Component, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { KENDO_DROPDOWNBUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_CARD } from '@progress/kendo-angular-layout';
import { AbstractGridComponent } from '@unity/abstract/abstract-grid.component';
import { ClientDetailedDto, ClientsClient } from '@unity/clients';
import { TypedDirective } from '@unity/directives/typed.directive';
import { GridSharedComponent } from '@unity/shared/composed/grid-shared/grid-shared.component';
import { ChipWorkflowStateSharedComponent } from '@unity/shared/presentation/chip-workflow-state-shared/chip-workflow-state-shared.component';
import { SortConfig } from '@unity/utils/types';
import { GridcellCurrencySharedComponent } from '../presentation/gridcell-currency-shared/gridcell-currency-shared.component';
import { LinkGridcellSharedComponent } from '../presentation/link-gridcell-shared/link-gridcell-shared.component';

@Component({
  selector: 'unity-grid-client-shared',
  standalone: true,
  imports: [
    KENDO_GRID,
    KENDO_CARD,
    KENDO_DROPDOWNBUTTON,
    GridSharedComponent,
    ChipWorkflowStateSharedComponent,
    TypedDirective,
    LinkGridcellSharedComponent,
    GridcellCurrencySharedComponent,
  ],
  templateUrl: './grid-client-shared.component.html',
  styleUrl: './grid-client-shared.component.scss',
})
export class GridClientSharedComponent extends AbstractGridComponent<ClientDetailedDto> {
  private readonly clientsClient = inject(ClientsClient);

  /* Inputs */
  public readonly $agreementId = input.required<number>({ alias: 'agreementId' });

  /* Resources */
  protected override resource = rxResource({
    params: () => {
      const query = this.$gridifyQuery();
      const agreementId = this.$agreementId();
      return query && agreementId ? { query, agreementId } : undefined;
    },
    stream: ({ params: { query, agreementId } }) =>
      this.clientsClient.getAllForAgreementAsDetailed(agreementId, query.page, query.pageSize, query.orderBy, query.filter),
  });

  /* Data */
  protected defaultSort: SortConfig[] = [
    {
      field: 'created_dt',
      dir: 'desc',
    },
  ];
}
